<template>
  <div id="contact-modal">
    <v-dialog v-model="theDialog" max-width="500px">
      <v-card>
        <v-img
          class="white--text align-end"
          height="100px"
          src="@/assets/images/contact-bg.jpg"
        >
          <v-card-title>Contact a Six Sigma Expert</v-card-title>
        </v-img>
        <v-card-text>
          <ContactForm
            @close-modal="theDialog = false"
            :the-dialog="theDialog"
            :is-modal="true"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ContactForm from "@/components/Forms/ContactForm";

export default {
  name: "contact-modal",
  components: {
    ContactForm,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      theDialog: false,
    };
  },
  watch: {
    dialog: {
      handler(val) {
        this.theDialog = val;
      },
    },
    theDialog: {
      handler(val) {
        this.$emit('update:dialog', val);
      },
    },
  },
};
</script>
